/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiRatings } from '../../data/interfaces';
import {
    FETCH_RATING_REQUEST, FETCH_RATING_SUCCESS, FETCH_RATING_FAILURE, POST_RATING_REQUEST,
    POST_RATING_SUCCESS, POST_RATING_FAILURE
} from '../types/rating';

export const fetchRatingsRequest = () => {
    return {
        type: FETCH_RATING_REQUEST
    }
}

export const fetchRatingsSuccess = (ratings: ApiRatings) => {
    return {
        type: FETCH_RATING_SUCCESS,
        payload: ratings
    }
}

export const fetchRatingsFailure = (error: string) => {
    return {
        type: FETCH_RATING_FAILURE,
        payload: error
    }
}

export const createRatingsRequest = () => {
    return {
        type: POST_RATING_REQUEST
    }
}

export const createRatingsSuccess = () => {
    return {
        type: POST_RATING_SUCCESS,
    }
}

export const createRatingsFailure = (error: string) => {
    return {
        type: POST_RATING_FAILURE,
        payload: error
    }
}
